import * as MdIcons from 'react-icons/md';

// Ícones para categorias de receita
export const incomeIcons = [
  'MdArrowUpward',
  'MdAttachMoney',
  'MdTrendingUp',
  'MdSavings',
  'MdAccountBalance',
  'MdWork',
  'MdBusiness',
  'MdCardGiftcard',
  'MdCelebration',
  'MdLocalAtm',
];

// Ícones para categorias de despesa
export const expenseIcons = [
  'MdArrowDownward',
  'MdMoneyOff',
  'MdShoppingCart',
  'MdRestaurant',
  'MdFastfood',
  'MdLocalGroceryStore',
  'MdLocalMall',
  'MdLocalCafe',
  'MdLocalBar',
  'MdLocalPizza',
  'MdCoffee',
  'MdHome',
  'MdHouse',
  'MdApartment',
  'MdWaterDrop',
  'MdPower',
  'MdWifi',
  'MdDirectionsCar',
  'MdLocalGasStation',
  'MdLocalTaxi',
  'MdFlight',
  'MdLocalShipping',
  'MdLocalHospital',
  'MdMedicalServices',
  'MdSpa',
  'MdFitnessCenter',
  'MdSports',
  'MdSportsBasketball',
  'MdSportsSoccer',
  'MdMovie',
  'MdMusicNote',
  'MdSchool',
  'MdComputer',
  'MdDevices',
  'MdPhoneAndroid',
  'MdPets',
  'MdChildCare',
  'MdFamilyRestroom',
  'MdBeachAccess',
  'MdReceipt',
  'MdLocalLaundryService',
  'MdLocalPharmacy',
  'MdLocalActivity',
  'MdLocalOffer',
  'MdMoreHoriz',
];

// Mapa de ícones Material para componentes React
export const iconMap = {
  // Receitas
  'arrow_upward': 'MdArrowUpward',
  'attach_money': 'MdAttachMoney',
  'trending_up': 'MdTrendingUp',
  'savings': 'MdSavings',
  'account_balance': 'MdAccountBalance',
  'work': 'MdWork',
  'business': 'MdBusiness',
  'card_giftcard': 'MdCardGiftcard',
  'celebration': 'MdCelebration',
  'local_atm': 'MdLocalAtm',
  
  // Despesas
  'arrow_downward': 'MdArrowDownward',
  'money_off': 'MdMoneyOff',
  'shopping_cart': 'MdShoppingCart',
  'restaurant': 'MdRestaurant',
  'fastfood': 'MdFastfood',
  'local_grocery_store': 'MdLocalGroceryStore',
  'local_mall': 'MdLocalMall',
  'local_cafe': 'MdLocalCafe',
  'local_bar': 'MdLocalBar',
  'local_pizza': 'MdLocalPizza',
  'coffee': 'MdCoffee',
  'home': 'MdHome',
  'house': 'MdHouse',
  'apartment': 'MdApartment',
  'water_drop': 'MdWaterDrop',
  'power': 'MdPower',
  'wifi': 'MdWifi',
  'directions_car': 'MdDirectionsCar',
  'local_gas_station': 'MdLocalGasStation',
  'local_taxi': 'MdLocalTaxi',
  'flight': 'MdFlight',
  'local_shipping': 'MdLocalShipping',
  'local_hospital': 'MdLocalHospital',
  'medical_services': 'MdMedicalServices',
  'spa': 'MdSpa',
  'fitness_center': 'MdFitnessCenter',
  'sports': 'MdSports',
  'sports_basketball': 'MdSportsBasketball',
  'sports_soccer': 'MdSportsSoccer',
  'movie': 'MdMovie',
  'music_note': 'MdMusicNote',
  'school': 'MdSchool',
  'computer': 'MdComputer',
  'devices': 'MdDevices',
  'phone_android': 'MdPhoneAndroid',
  'pets': 'MdPets',
  'child_care': 'MdChildCare',
  'family_restroom': 'MdFamilyRestroom',
  'beach_access': 'MdBeachAccess',
  'receipt': 'MdReceipt',
  'local_laundry_service': 'MdLocalLaundryService',
  'local_pharmacy': 'MdLocalPharmacy',
  'local_activity': 'MdLocalActivity',
  'local_offer': 'MdLocalOffer',
  'more_horiz': 'MdMoreHoriz',
  'category': 'MdCategory',
};

// Mapa reverso: de React Icon para string do backend
export const reverseIconMap = Object.entries(iconMap).reduce((acc, [key, value]) => {
  acc[value] = key;
  return acc;
}, {});

// Função para obter o componente do ícone
export const getIconComponent = (iconName) => {
  const iconKey = iconMap[iconName] || 'MdCategory';
  return MdIcons[iconKey] || MdIcons.MdCategory;
};

// Função para obter o nome do backend a partir do nome do React Icon
export const getBackendIconName = (reactIconName) => {
  return reverseIconMap[reactIconName] || 'category';
};
